import { FORMAT } from "../constants/Constant";
import { COUNTRY } from "../constants/CountryConstant";
import CompanyDetailService from "../services/CompanyDetailService";
import Table from "../services/table";
import Tenant from "../services/tenant";
import {
    showAlert,
    removeLoader,
    showLoader,
    DKButton,
    showToast,
    TOAST_TYPE
  } from "deskera-ui-library";
import SideBarService from "../services/sidebar";
import UserManager from "./UserManager";
import { deepClone } from "../utility/Utility";

export const TENANT = {
    TENANT_WORK_WEEK: 'TENANT_WORK_WEEK',
    USER_ID: "USER_ID",
    IAM_USER_ID: "IAM_USER_ID",
    USER_NAME: 'USER_NAME',
    USER_ROLE: 'USER_ROLE',
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME',
    EMAIL_ID: 'EMAIL_ID',
    FULL_NAME: 'FULL_NAME',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    IS_ADMIN: 'IS_ADMIN',
    DESIGNATION: 'DESIGNATION',
    DATE_OF_CREATION: 'DATE_OF_CREATION',
    COUNTRY_CODE: 'COUNTRY_CODE',
    CURRENCY_CODE: 'CURRENCY_CODE',
    ORGANIZATION_NAME : 'ORGANIZATION_NAME',
    CONFIG: 'CONFIG',
    DATE_FORMAT: 'DATE_FORMAT',
    SHORT_DATE_FORMAT: 'SHORT_DATE_FORMAT',
    DECIMAL_FORMAT: 'DECIMAL_FORMAT',
    ERP_INTEGATION_SETTING: "ERP_INTEGATION_SETTING",
    IS_CONTRACTOR:"IS_CONTRACTOR",
    IS_DIRECT_PAY_ENABLED: "IS_DIRECT_PAY_ENABLED",
    CHECKHQ_COMPANY_TYPE: "CHECKHQ_COMPANY_TYPE",
    CHECKHQ_EMPLOYEE_ID: "CHECKHQ_EMPLOYEE_ID",
    GEO_LOCATION_ENABLE:"GEO_LOCATION_ENABLE",
    ADDRESS: "ADDRESS",
    IS_HIRING_ADMIN:"IS_HIRING_ADMIN",
    IS_OWNER: "IS_OWNER",
    IS_SHIFT_MANAGEMENT_ENABLED: "IS_SHIFT_MANAGEMENT_ENABLED",
    DATE_OF_JOINING: "DATE_OF_JOINING",
    EXPENSE_ROLE: "EXPENSE_ROLE",
    STATE_CODE: "STATE_CODE",
    PLAN_NAME: "PLAN_NAME",
    EMPLOYEE_PROFILE_STAGES: "EMPLOYEE_PROFILE_STAGES",
    IS_ATTENDANCE_ATTACHMENT_ENABLED: "IS_ATTENDANCE_ATTACHMENT_ENABLED",
    DEFAULT_PAYSLIP:"DEFAULT_PAYSLIP",
    IS_MANAGER: "IS_MANAGER",
    OWNER_ID: "OWNER_ID",
    USER_STATUS: "USER_STATUS",
    TAX_DETAILS: "TAX_DETAILS",
    TEAMS: "TEAMS",
    ERP_TENANT_ID: "ERP_TENANT_ID",
    APPRAISAL_REPORTING_MANAGER: "APPRAISAL_REPORTING_MANAGER",
    CUSTOM_FIELD_SECTION_ENABLED: "CUSTOM_FIELD_SECTION_ENABLED",
    PW_REGION: "PW_REGION",
    IS_PW_CONTRACTOR: "IS_PW_CONTRACTOR",
    PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN: "PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN"
}
export class TenantService {
    static tenantData: any = {
        TENANT_WORK_WEEK:[],
        USER_ID: '',
        IAM_USER_ID: '',
        USER_NAME: '',
        USER_ROLE: '',
        FIRST_NAME: '',
        LAST_NAME: '',
        EMAIL_ID: '',
        FULL_NAME: '',
        IS_ADMIN: false,
        DESIGNATION: '',
        DATE_OF_CREATION: '',
        COUNTRY_CODE: '',
        CURRENCY_CODE: '',
        ORGANIZATION_NAME : '',
        CONFIG: '',
        DATE_FORMAT: '',
        SHORT_DATE_FORMAT: '',
        DECIMAL_FORMAT: '',
        ERP_INTEGATION_SETTING: false,
        IS_CONTRACTOR: false,
        IS_DIRECT_PAY_ENABLED: false,
        IS_HIRING_ADMIN: false,
        IS_OWNER: false,
        IS_SHIFT_MANAGEMENT_ENABLED: false,
        DATE_OF_JOINING:"",
        EXPENSE_ROLE: "",
        REFRESH_TOKEN:'',
        STATE_CODE: "",
        PLAN_NAME: "",
        IS_ATTENDANCE_ATTACHMENT_ENABLED: false,
        DEFAULT_PAYSLIP: [],
        IS_MANAGER: false,
        OWNER_ID: "",
        USER_STATUS: "",
        TAX_DETAILS: null,
        TEAMS: [],
        ERP_TENANT_ID: "",
        APPRAISAL_REPORTING_MANAGER: false,
        CUSTOM_FIELD_SECTION_ENABLED: false,
        PW_REGION: "",
        IS_PW_CONTRACTOR: false,
        PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN: false
    };

    static getTenantData() {
        Table.getTenantData().then(
            (response) => {
                if (response && response['tenant']) {
                    this.tenantData[TENANT.TENANT_WORK_WEEK] = response['tenant']['workWeekDetails'];
                    this.tenantData[TENANT.DATE_OF_CREATION] = response['tenant']['dateOfCreation'];
                    this.tenantData[TENANT.COUNTRY_CODE] = response['tenant']['countryCode'];
                    this.tenantData[TENANT.CURRENCY_CODE] = response['tenant']['currency'];
                    this.tenantData[TENANT.ORGANIZATION_NAME] = response['tenant']['organizationName'];
                    this.tenantData[TENANT.IS_DIRECT_PAY_ENABLED] = response['tenant']['isAddBankAcc'];
                    this.tenantData[TENANT.ADDRESS] = response['tenant']['address'];
                    this.tenantData[TENANT.STATE_CODE] = this.tenantData[TENANT.ADDRESS] ? this.tenantData[TENANT.ADDRESS]['state'] : "";
                    this.tenantData[TENANT.IS_SHIFT_MANAGEMENT_ENABLED] = response['tenant']['enableShiftManagement'];
                    this.tenantData[TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED] = response['tenant']['isAttendanceAttachmentsEnabled'];
                    this.tenantData[TENANT.ERP_TENANT_ID] = response['tenant']['erpTenantId']
                    this.tenantData[TENANT.CUSTOM_FIELD_SECTION_ENABLED] = response['tenant']['customSectionFieldsEnabled'] || false;
                    this.tenantData[TENANT.PW_REGION] = response['tenant']['pwRegion'] || "";
                    this.tenantData[TENANT.IS_PW_CONTRACTOR] = response['tenant']['isContractor'] || false;
                }
            }, (error) => {
                console.log(error);
            }
        );
    }

    static getTenantConfig() {
        CompanyDetailService.getTenantConfig().then(
            (response) => {
                if (response) {
                    this.tenantData[TENANT.CONFIG] = response;
                    CompanyDetailService.setDateFormat(response['dateFormat']);
                    CompanyDetailService.setDecimalFormat(response['decimalFormat']);
                    CompanyDetailService.setGeoFencing(response['geofencing']);
                }
            }, (error) => {
                if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US) {
                    CompanyDetailService.setDateFormat(FORMAT.MMDDYYYY);
                } else {
                    CompanyDetailService.setDateFormat(FORMAT.DDMMYYYY);
                }
            }
        );
    }
    static async getUserData() {
        showLoader();
        return await Tenant.getUserDetails().then(
            (response: any) => {
                removeLoader();
                if (response?.status === "OK") {
                    this.tenantData[TENANT.USER_ID] = response['user']['userId'];
                    this.tenantData[TENANT.IAM_USER_ID] = response['user']['iamUserId'];
                    this.tenantData[TENANT.DESIGNATION] = response['user']['designation'];
                    this.tenantData[TENANT.EMAIL_ID] = response['user']['emailId'];
                    this.tenantData[TENANT.FIRST_NAME] = response['user']['firstName'];
                    this.tenantData[TENANT.LAST_NAME] = response['user']['lastName'];
                    this.tenantData[TENANT.FULL_NAME] = `${this.tenantData[TENANT.FIRST_NAME]} ${this.tenantData[TENANT.LAST_NAME]}`;
                    this.tenantData[TENANT.IS_CONTRACTOR] = (response['user']['type'] == "CONTRACTOR" ? true : false);
                    this.tenantData[TENANT.EMPLOYEE_PROFILE_STAGES] = response['user']['profileStages'];
                    this.tenantData[TENANT.APPRAISAL_REPORTING_MANAGER] = response['user']['privileges'] && response['user']['privileges']['appraisalReportingManager'] ? response['user']['privileges']['appraisalReportingManager'] : false;
                    let isOwner = false;
                    let isAdmin = false;
                    let isHiringAdmin = false;
                    const userDetails = deepClone(UserManager.getUserDetails());
                    const usersRoleShortInfo = userDetails?.roleShortInfo;
                    const organizationRole = this.getOrganizationRole(usersRoleShortInfo, "ORGANISATION");
                    const peopleRole = this.getOrganizationRole(usersRoleShortInfo, "PEOPLE");
                    for (const role of response['user'].roles) {
                        if (role.appName === 'PEOPLE') {
                            if (organizationRole === 'OWNER' && peopleRole === 'ADMIN') {
                                isOwner = true;
                                isAdmin = true;
                                break;
                            } else if(role.name === 'OWNER') {
                                isOwner = true;
                                isAdmin = true;
                                
                            } else if(role.name === 'ADMIN') {
                                isHiringAdmin = false;
                                isAdmin = true;
                            } else if(role.name === 'HIRINGADMIN') {
                                isHiringAdmin = true;
                                isAdmin = false;
                            }
                        }
                    }
        
                    this.tenantData[TENANT.IS_ADMIN] = isAdmin;
                    this.tenantData[TENANT.IS_OWNER] = isOwner;
                    this.tenantData[TENANT.IS_HIRING_ADMIN] = isHiringAdmin;
                    this.tenantData[TENANT.DATE_OF_JOINING] = response['user']['dateOfJoining']
                    const user = response['user'];
                    let role = (user.roles && user.roles.length > 0) ? user.roles[0].name : '';
                    if (role = this.checkRoleInTeam(user, role) == 'MANAGER') {
                        this.tenantData[TENANT.IS_MANAGER] = true;
                    }
                    
                    

                    dispatchEvent(new CustomEvent('onSideBarLoad', { detail: { isSideBarLoad: true } }));
                    return Promise.resolve(response);
                } else {
                    return Promise.reject(response);
                }
            }, (error) => {
            removeLoader();
            return Promise.reject(error);
        });
    }

    static checkRoleInTeam(user, userRole) {
        let userId = user.userId;
        let role = userRole;
        if (user.teams && user.teams.length > 0) {
            let teams = user.teams;
            if (teams && teams.length > 0) {
                this.tenantData[TENANT.TEAMS] = teams?.map(t=>{
                    return {
                        ...t,
                        members: t.members.map(m=>{
                            return {
                                ...m,
                                name: `${m.firstName} ${m.lastName}`
                            }
                        })
                        
                    }
                })
                for(let i = 0; i < teams.length; i++) {
                    let element = teams[i];
                    if (element.members && element.members.length > 0) {
                        let teamMembers = element.members;
                        for( let index = 0; index < teamMembers.length; index++) {
                            let object = teamMembers[index];
                            if (object.userId == userId) {
                                role = object.roles[0];
                                if (role == 'MANAGER') {
                                    return role = 'MANAGER';
                                } else {
                                    role = 'USER';
                                }
                            }
                        }
                    }
                }
            }
        }
        return role;
    }

    static setData(tenantData) {
        this.tenantData = tenantData;
    }

    static clear() {
        this.setData({});
    }

    static getData() {
        return this.tenantData;
    }

    static get(field) {
        return TenantService.tenantData[field];
    }

    static set(field, value) {
        this.tenantData[field] = value;
    }

    static getOrganizationRole(roleGroup, appName) {
        let role = "USER";
        const roleIndex = roleGroup?.findIndex(r => r.appName === appName);
        if(roleIndex != -1 && roleGroup) {
            const group = roleGroup[roleIndex];
            role = group?.shortCode.toUpperCase();
        }
        return role;
    }

    static setTenantData(response) {
        if (response && response['tenant']) {
            this.tenantData[TENANT.TENANT_WORK_WEEK] = response['tenant']['workWeekDetails'];
            this.tenantData[TENANT.DATE_OF_CREATION] = response['tenant']['dateOfCreation'];
            this.tenantData[TENANT.COUNTRY_CODE] = response['tenant']['countryCode'];
            this.tenantData[TENANT.CURRENCY_CODE] = response['tenant']['currency'];
            this.tenantData[TENANT.ORGANIZATION_NAME] = response['tenant']['organizationName'];
            this.tenantData[TENANT.IS_DIRECT_PAY_ENABLED] = response['tenant']['isAddBankAcc'];
            this.tenantData[TENANT.ADDRESS] = response['tenant']['address'];
            this.tenantData[TENANT.STATE_CODE] = this.tenantData[TENANT.ADDRESS] ? this.tenantData[TENANT.ADDRESS]['state'] : "";
            this.tenantData[TENANT.IS_SHIFT_MANAGEMENT_ENABLED] = response['tenant']['enableShiftManagement'];
            this.tenantData[TENANT.PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN] = response['tenant']['progressEmployeeProfileSaveButton'];
        }
    }

}
